(() => {
if (!customElements.get('wf-tabs')) {
  class WFTabs extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.bound = false;
    }

    get tabs() {
      return Array.from(this.querySelectorAll('[role="tab"]'));
    }

    onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab && this.contains(tab)) this.activate(tab);
    };

    onKeydown = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;
      const tabs = this.tabs;
      const current = tabs.indexOf(tab);
      let next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      this.activate(tabs[next]);
    };

    onBlockSelect = (event) => {
      if (!this.contains(event.target)) return;
      const tab = this.querySelector(`[role="tab"][data-block-id="${event.detail.blockId}"]`);
      if (tab) this.activate(tab, false);
    };

    activate(activeTab, focus = true) {
      this.tabs.forEach((tab) => {
        const active = tab === activeTab;
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (panel) panel.hidden = !active;
      });
      if (focus) activeTab.focus();
    }
  }
  customElements.define('wf-tabs', WFTabs);
}

if (!customElements.get('wf-countdown')) {
  class WFCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      if (!Number.isFinite(this.end) || this.end <= Date.now()) return;
      this.hidden = false;
      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    update() {
      const remaining = this.end - Date.now();
      if (remaining <= 0) {
        window.clearInterval(this.timer);
        this.hidden = true;
        return;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      this.querySelector('[data-days]').textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      this.querySelector('[data-hours]').textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      this.querySelector('[data-minutes]').textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      this.querySelector('[data-seconds]').textContent = String(totalSeconds % 60).padStart(2, '0');
    }
  }
  customElements.define('wf-countdown', WFCountdown);
}

const initWFReviews = (root = document) => {
  root.querySelectorAll('.wf-reviews[data-autoplay="true"]').forEach((section) => {
    if (section.dataset.autoplayReady === 'true') return;
    const track = section.querySelector('.wf-reviews__track');
    const cards = Array.from(section.querySelectorAll('.wf-review'));
    if (!track || cards.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    section.dataset.autoplayReady = 'true';
    let index = 0;
    const delay = Number(section.dataset.delay) || 7000;
    section.wfReviewTimer = window.setInterval(() => {
      index = (index + 1) % cards.length;
      cards[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }, delay);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initWFReviews(), { once: true });
} else {
  initWFReviews();
}
document.addEventListener('shopify:section:load', (event) => initWFReviews(event.target));
})();
